/**
 * @file: GoodsPc.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 业务数据管理中心-入库管理-食品入库
 */
import request from '@/utils/request'

/**
 * 小程序-获取今日入库食品列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appletGoodsTodayListGet(data) {
  return request({
    type: 'biz',
    url: 'applet/goods/today/list/get',
    method: 'post',
    data
  })
}

/**
 * 后台保存标识(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function goodsBarcodeStatusAdd(data) {
  return request({
    type: 'biz',
    url: 'goods/barcode/status/add',
    method: 'post',
    data
  })
}

/**
 * 获取食品保存标识(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function goodsBarcodeStatusGet(data) {
  return request({
    type: 'biz',
    url: 'goods/barcode/status/get',
    method: 'post',
    data
  })
}

/**
 * 扫码枪扫码推送信息(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function goodsPushAdd(data) {
  return request({
    type: 'biz',
    url: 'goods/push/add',
    method: 'post',
    data
  })
}

/**
 * 添加食品信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/add',
    method: 'post',
    data
  })
}

/**
 * 批量删除食品信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/batch/delete',
    method: 'post',
    data
  })
}

/**
 * 根据食品id获取食品详情(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicByIdGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/by/id/get',
    method: 'post',
    data
  })
}

/**
 * 删除食品信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/delete',
    method: 'post',
    data
  })
}

/**
 * 根据食品条码编号获取食品信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicInfoGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/info/get',
    method: 'post',
    data
  })
}

/**
 * 根据食品名称、编码获取食品基本信息(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicInfoNameGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/info/name/get',
    method: 'post',
    data
  })
}

/**
 * 根据组织运营商获取食品列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicListByOrgConGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/list/by/org/con/get',
    method: 'post',
    data
  })
}

/**
 * 获取食品列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改食品信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/update',
    method: 'post',
    data
  })
}

/**
 * 将条形码导出成word文档(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBasicWordGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/basic/word/get',
    method: 'post',
    data
  })
}

/**
 * 批量删除食品批次信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBatchAllDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/batch/all/delete',
    method: 'post',
    data
  })
}

/**
 * 删除食品批次信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/batch/delete',
    method: 'post',
    data
  })
}

/**
 * 根据食品批次id获取食品详细信息(cme)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBatchDetailGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/batch/detail/get',
    method: 'post',
    data
  })
}

/**
 * 食品入库（原：食品信息录入）(ndj)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBatchInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/batch/info/add',
    method: 'post',
    data
  })
}

/**
 * 获取食品批次列表信息(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBatchListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/batch/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改食品批次信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsBatchUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/batch/update',
    method: 'post',
    data
  })
}

/**
 * 根据供应商id获取今日采购明细(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsTodayDetailListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/today/detail/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取今日入库食品列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsTodayListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/today/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取今日采购公示(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcGoodsTodayPurchaseGet(data) {
  return request({
    type: 'biz',
    url: 'pc/goods/today/purchase/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/GoodsPc.js